import React, { useState } from 'react';
import { Container, Row, Col, Card, Image } from 'react-bootstrap';
import Footer from '../components/Footer'; // Import the Footer component

const ServiceCard = ({ title, description }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isClicked, setIsClicked] = useState(false);

  return (
    <Card 
      className={`shadow-sm p-3 mb-4 bg-white rounded border transition-all cursor-pointer ${
        isHovered ? 'shadow-xl border-black scale-105' : 'border-gray-300'
      } ${isClicked ? 'bg-gray-900 text-white' : ''}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={() => setIsClicked(!isClicked)}
      style={{ transition: 'transform 0.3s ease, box-shadow 0.3s ease', height: '200px' }}
    >
      <Card.Body>
        <Card.Title className="text-dark fw-bold">{title}</Card.Title>
        <Card.Text className="text-muted">{description}</Card.Text>
      </Card.Body>
    </Card>
  );
};

const Services = () => {
  const serviceList = [
    {
      title: "Case Management",
      description: "A case manager will assess your needs and coordinate your rehabilitation resources."
    },
    {
      title: "Psychological Counselling",
      description: "Therapy to support recovery from psychological trauma after a motor vehicle accident."
    },
    {
      title: "Social Work",
      description: "Social workers provide therapy and coping strategies for anxiety, PTSD, and depression."
    },
    {
      title: "In-Home Therapy",
      description: "Therapy at home for clients facing physical limitations or discomfort in office settings."
    },
    {
      title: "Physiotherapy and Massage Therapy",
      description: "Evidence-based treatments to promote rehabilitation and pain management."
    },
    {
      title: "Social Work Assessment",
      description: "Assessments to understand your personal and social circumstances for tailored support."
    },
    {
      title: "Driving Anxiety Therapy",
      description: "Cognitive behavioral therapy and exposure therapy to help overcome driving fears."
    },
    {
      title: "Solution-focused Brief Therapy (SFBT)",
      description: "A goal-oriented therapy focusing on solutions rather than problems to achieve positive outcomes."
    },
    {
      title: "Cognitive Processing Therapy (CPT)",
      description: "A structured therapy to help individuals recover from trauma by addressing negative thought patterns."
    }
  ];

  return (
    <>
      <Container className="mt-5">
        {/* Image Section */}
        <Row className="text-center mb-4">
          <Col>
            <Image 
              src="/images/services.png" 
              alt="Our Services" 
              fluid 
              className="rounded shadow-sm" 
              style={{ maxWidth: '100%', height: 'auto' }}
            />
          </Col>
        </Row>

        {/* Heading */}
        <Row className="text-center mb-4">
          <Col>
            <h1 className="fw-bold text-dark">Our Services</h1>
            <p className="text-muted">We provide a range of specialized services to support your recovery after a motor vehicle accident.</p>
          </Col>
        </Row>

       {/* Services List */}
       <Row>
          {serviceList.map((service, index) => (
            <Col md={6} lg={4} key={index}>
              <ServiceCard {...service} />
            </Col>
          ))}
        </Row>

        {/* Language Support Section */}
                {/* Language Support Section */}
                <Row className="mt-5">
          <Col>
            <div 
              className="p-4 bg-light rounded shadow-sm text-center"
              style={{ border: '1px solid #ddd' }}
            >
              <h4 className="fw-bold text-dark">Language Support</h4>
              <p className="text-muted">
                We support patients in the following: English, Somali, Arabic, Dari, Farsi, and Azari-Turkish.
              </p>
            </div>
          </Col>
        </Row>

        {/* Additional Support Section */}
        <Row className="mt-5">
          <Col>
            <div 
              className="p-4 bg-light rounded shadow-sm"
              style={{ border: '1px solid #ddd' }}
            >
              <h4 className="fw-bold text-dark">Additional Support Services</h4>
              <p className="text-muted">
                <strong>We support applying the following:</strong> ODSP, Disability Tax Credit.
                We assist in completing and submitting documentation for provincially and federally
                funded programs, including the Ontario Disability Support Program,
                Disability Tax Credit, and CPP Disability Benefit. We sit with the client and conduct an
                assessment to ensure accurate and timely documentation to apply for the respective
                funding program.
              </p>
              <p className="text-muted">
                <strong>Mental Health Workshops and Consulting:</strong> Our workplace mental health workshops and consulting services help leaders and staff
                recognize mental health pointers, manage distress, build resilience, reduce challenging
                interactions, address burnout, and navigate crises. We provide tools to foster
                psychological health, healing, and safety in the workplace.
              </p>
              <p className="text-muted">
                <strong>Healing Circles:</strong> The healing circle is a safe space where we can share openly and confidentially how
                we’re feeling and what we’re thinking. You are encouraged to bring yourself to the Circle
                just as you are without pretense, shame, or false bravado. They help us step out of
                ordinary time into a safe and accepting environment to explore our healing. With open
                minds, we work together to discover the best ways to remove obstacles to healing,
                alleviate suffering, and deepen our healing capacity. With open hearts, we access our
                inner guidance to understand where the greatest healing—in body, emotions, mind, and
                spirit—can occur. The healing circle team strives to provide affordable services for
                adults, youth, and communities for affordable sessions either weekly, bi-weekly, or
                monthly.
              </p>
            </div>
          </Col>
        </Row>
      </Container>

      {/* Footer Section */}
      <Footer />
    </>
  );
};

export default Services;
